var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SimpleCard',{attrs:{"no-back":"","schema":_vm.schema,"route-create":_vm.schema.routes.create.name}},[_c('DynamicListPage',{attrs:{"schema":_vm.schema,"service":_vm.service},on:{"moreActions":_vm.moreActions}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }